<template>
  <div class="v-application--wrap" ref="blogWrapper">
    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Libre+Baskerville&family=Playfair+Display:wght@400;500;600;700&family=Poppins:wght@300;400;500;600;700&display=swap">
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css">
    <div id="blog" class="v-main">
      <div class="v-main__wrap">
        <div class="v-overlay v-overlay--absolute theme--dark" :class="{'v-overlay--active': openMenu}" @click="openMenu = !openMenu">
          <div class="v-overlay__scrim" style="opacity: 0.46; background-color: rgb(33, 33, 33); border-color: rgb(33, 33, 33);"></div>
          <div class="v-overlay__content"></div>
        </div>
        <header id="header-sticky" class="header header--default fixed header--transparent">
          <div class="container">
            <div class="header__left">
              <a href="/" class="ps-logo ps-logo--white router-link-active">
                <img src="/static/img/logo_white_new.png" alt="Indiefy blog">
              </a>
              <a href="/" class="ps-logo router-link-active">
                <img src="/static/img/logo_dark_new.png" alt="Indiefy blog">
              </a>
            </div>
            <div class="header__center">
              <ul class="menu">
                <li>
                  <a href="/" v-if="lang === 'es'">Inicio</a>
                  <a href="/" v-else>Home</a>
                </li>
                <li>
                  <a href="/blog">Blog</a>
                </li>
                <li>
                  <a href="/blog/category/all" class="" v-if="lang === 'es'">
                    Categorias
                  </a>
                  <a href="/blog/category/all" class="" v-else>
                    Categories
                  </a>
                </li>
                <li>
                  <a href="/landing/about-us" v-if="lang === 'es'">Acerca de nosotros</a>
                  <a href="/landing/about-us" v-else>About Us</a>
                </li>
              </ul>
            </div>
            <div class="header__right"></div>
          </div>
        </header>
        <header class="header header--center header--mobile" id="header-sticky">
          <div class="container">
            <div class="header__wrapper">
              <div class="header__left">
                <a href="/" class="ps-logo router-link-active">
                  <img src="/static/img/logo_dark_new.png" alt="Indiefy blog">
                </a>
              </div>
              <div class="header__right">
                <a class="header__toggle" @click="openMenu = !openMenu">
                  <i class="feather icon icon-menu"></i>
                </a>
              </div>
            </div>
          </div>
        </header>
        <aside class="mobile-menu" :class="{'open': openMenu}">
          <div class="ps-panel--menu-sidebar">
            <div class="ps-panel__header">
              <a href="/" class="ps-logo router-link-active">
                <img src="/static/img/logo_dark_new.png" alt="Indiefy blog">
              </a>
              <a class="ps-drawer__close" @click="openMenu = !openMenu">
                <i class="feather icon icon-x"></i>
              </a>
            </div>
            <div class="ps-panel__content">
              <div role="list" class="v-list menu--mobile v-sheet theme--light">
                <div class="v-list-group v-list-group--no-action">
                  <div tabindex="0" aria-expanded="false" role="button" class="v-list-group__header v-list-item v-list-item--link theme--light collapsed" data-toggle="collapse" data-target="#collapseOne">
                    <div class="v-list-item__content">
                      <a href="/" v-if="lang === 'es'">Inicio</a>
                      <a href="/" v-else>Home</a>
                    </div>
                  </div>
                </div>
                <div class="v-list-group v-list-group--no-action">
                  <div tabindex="0" aria-expanded="false" role="button" class="v-list-group__header v-list-item v-list-item--link theme--light">
                    <div class="v-list-item__content">
                      <a href="/blog">Blog</a>
                    </div>
                  </div>
                </div>
                <div class="v-list-group v-list-group--no-action">
                  <div tabindex="0" aria-expanded="false" role="button" class="v-list-group__header v-list-item v-list-item--link theme--light">
                    <div class="v-list-item__content">
                      <a href="/blog/category/all" class="" v-if="lang === 'es'">
                        Categorias
                      </a>
                      <a href="/blog/category/all" class="" v-else>
                        Categories
                      </a>
                    </div>
                  </div>
                </div>
                <div tabindex="-1" role="listitem" class="v-list-item theme--light">
                  <div class="v-list-item__content">
                    <a href="/landing/about-us" v-if="lang === 'es'">Acerca de nosotros</a>
                    <a href="/landing/about-us" v-else>About Us</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </aside>
        <BlogMain v-if="page == 'Blog'"></BlogMain>
        <BlogPost v-if="page == 'Post'"></BlogPost>
        <BlogCategory v-if="page == 'Category'"></BlogCategory>
        <footer class="ps-footer--second dark">
          <div class="ps-footer__top">
            <div class="container">
              <div class="row">
                <div class="col-lg-3 col-md-12 pb-3">
                  <aside class="ps-widget ps-widget--about-site">
                    <a href="/" aria-current="page" class="ps-logo ps-logo--white active ">
                      <img src="https://indiefy.net/static/img/logo_white_new.png" alt="Indiefy blog" style="width: 136px;max-height:none;">
                    </a>
                    <a href="https://help.indiefy.net/" target="_blank">https://help.indiefy.net/</a>
                  </aside>
                </div>
                <div class="col-lg-3 col-sm-4 col-6">
                  <aside class="ps-widget ps-widget--footer">
                    <h4 class="ps-widget__heading">
                      <span v-if="lang === 'es'">Enlaces R&aacute;pidos</span>
                      <span v-else>Quick Links</span>
                    </h4>
                    <div class="ps-widget__content">
                      <ul class="ps-list">
                        <li>
                          <a href="https://help.indiefy.net/" class="" target="_blank">
                            {{ lang === 'es' ? 'Ayuda' : 'Help' }}
                          </a>
                        </li>
                        <li>
                          <a href="/terms#terms-conditions" class="">
                            {{ lang === 'es' ? 'Términos y condiciones' : 'Terms & Conditions' }}
                          </a>
                        </li>
                        <li>
                          <a href="/our-artists" class="">
                            {{ lang === 'es' ? 'Artistas' : 'Artist' }}
                          </a>
                        </li>
                        <li>
                          <a href="/blog?lang=es" class="">
                            Blog Español
                          </a>
                        </li>
                        <li>
                          <a href="/blog?lang=en" class="">
                            Blog English
                          </a>
                        </li>
                      </ul>
                    </div>
                  </aside>
                </div>
                <div class="col-lg-3 col-sm-4 col-6">
                  <aside class="ps-widget ps-widget--footer">
                    <h4 class="ps-widget__heading">
                      <span v-if="lang === 'es'">Categorias</span>
                      <span v-else>Categories</span>
                    </h4>
                    <div class="ps-widget__content">
                      <ul class="ps-list">
                        <li>
                          <a href="/blog/category/all" target="_blank">
                            <div v-if="lang === 'es'">Todos</div>
                            <div v-else>All</div>
                          </a>
                        </li>
                        <li v-for="category in categories" v-bind:key="category._id">
                          <a :href="'/blog/category/'+category.key" class="" target="_blank">
                            <div>{{ getTextByLang({category}, 'category', lang) }}</div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </aside>
                </div>
                <div class="col-lg-3  col-sm-4 col-12">
                  <aside class="ps-widget ps-widget--footer ps-widget--address pt-sm-0 pt-3">
                    <h4 class="ps-widget__heading">
                      <span v-if="lang === 'es'">Direcci&oacute;n</span>
                      <span v-else>Address</span>
                    </h4>
                    <div class="ps-widget__content">
                      <p>Agustin Yañez 2820, Guadalajara,<br>JAL. M&eacute;xico, 44690</p>
                    </div>
                  </aside>
                </div>
              </div>
            </div>
          </div>
          <div class="ps-footer__bottom">
            <div class="container">
              <div class="row">
                <div class="col-md-6">
                  <div class="ps-footer__copyright">
                    <p>
                      © {{ year }}. Copyright
                      <a href="https://indiefy.net/">Indiefy Inc.</a>
                      <span v-if="lang === 'es'">Todos los derechos reservados.</span>
                      <span v-else>All right reverved.</span>
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="ps-footer__social">
                    <ul class="ps-list--social ps-social-links">
                      <li><a href="https://www.facebook.com/indiefyapp" target="_blank"><i class="fa fa-facebook"></i></a></li>
                      <li><a href="https://www.instagram.com/indiefyapp/" target="_blank"><i class="fa fa-instagram"></i></a></li>
                      <li><a href="https://www.youtube.com/channel/UCIb1zDHx1LGw0HB59zbmWIA" target="_blank"><i class="fa fa-youtube-play"></i></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import BlogMain from './blog-components/BlogMain'
import BlogPost from './blog-components/BlogPost'
import BlogCategory from './blog-components/BlogCategory'
import primaryMenu from '../data/menu-blog'
import Blog from '../services/blog'
import Filters from './utils/filters'

export default {
  name: 'BlogLayout',
  data () {
    return {
      lang: 'es',
      openMenu: false,
      page: '',
      categories: [],
      year: new Date().getFullYear()
    }
  },
  methods: {
    handleScrolll: function () {
      let number = window.pageXOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      const header = document.getElementById('header-sticky')
      if (header !== null) {
        if (number >= 300) {
          header.classList.add('header--sticky')
        } else {
          header.classList.remove('header--sticky')
        }
      }
    },
    getTextByLang: Filters.getTextByLang
  },
  computed: {
    menuItems: function () {
      return primaryMenu
    }
  },
  created: function () {
    this.page = this.$route.name

    Blog.getCategoryAndTotals().then(response => {
      this.categories = response.data.categories
    })

    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
    }
  },
  mounted: function () {
    window.removeEventListener('scroll', this.handleScrolll)
    window.addEventListener('scroll', this.handleScrolll)

    // let scriptGoogle = document.createElement('script')
    // scriptGoogle.setAttribute('src', 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8326584585992829')
    // scriptGoogle.setAttribute('crossorigin', 'anonymous')

    // eslint-disable-next-line
    // window.$(this.$refs.blogWrapper).append(scriptGoogle)
  },
  components: {
    BlogMain,
    BlogPost,
    BlogCategory
  }
}
</script>
<style lang="scss" scoped>
@import "../../static/fonts-blog/font-awesome/css/font-awesome.css";
@import "../assets/sass/blog/vars.scss";
@import "../assets/sass/blog/iconfont.scss";
@import "../assets/sass/blog/button.scss";
@import "../assets/sass/blog/v-list-group.scss";
@import "../assets/sass/blog/list.scss";
@import "../assets/sass/blog/application.scss";
@import "../assets/sass/blog/v-list.scss";
@import "../assets/sass/blog/v-icon.scss";
@import "../assets/sass/blog/pages.scss";
@import "../assets/sass/blog/header.scss";
@import "../assets/sass/blog/attraction.scss";
@import "../assets/sass/blog/section.scss";
@import "../assets/sass/blog/block.scss";
@import "../assets/sass/blog/form.scss";
@import "../assets/sass/blog/widget.scss";
@import "../assets/sass/blog/footer.scss";
</style>



// WEBPACK FOOTER //
// src/components/BlogLayout.vue